import React from 'react';
import classNames from 'classnames';

import './styles.css';

const EdditableFormField = ({children, className}: any) => {
  return (
    <div className={classNames('EdditableFormField', className)}>
      {children}
    </div>
  );
};

export default EdditableFormField;
